$('document').ready(function () {
        if (document.getElementById('wistia_simple_video_24')) {

            var videoPlayButton,
                videoWrapper = $('.video-wrapper'),
                video = $('video').get(0);

            function videoPlay() {
                video.play();
                videoWrapper.removeClass('stop');
                videoPlayButton.animate({opacity: 0}, 500);
                video.setAttribute("controls", "controls");
            }

            function videoStop() {
                video.pause();
                videoWrapper.addClass('stop');
                videoPlayButton.animate({opacity: 0.5}, 500);
            }

            function videoSwitch() {
                if (videoWrapper.hasClass('stop')) {
                    videoPlay();
                } else {
                    videoStop();
                }
            }

            function formatVideoPlayButton() {
                videoWrapper.append('\
            <svg class="video-overlay-play-button" viewBox="0 0 200 200" alt="Play video">\
                <circle cx="100" cy="100" r="90" fill="none" stroke-width="15" stroke="#c1c1c1"/>\
                <polygon points="70, 55 70, 145 145, 100" fill="#c1c1c1"/>\
            </svg>\
        ');
                videoPlayButton = $('.video-overlay-play-button');
                videoPlayButton.on('click', videoSwitch);
            }

            formatVideoPlayButton();
        }
    }
);

// videoMethods = {
//     // renderVideoPlayButton: function () {
//     //     if (videoWrapper.contains(video)) {
//     //         this.formatVideoPlayButton();
//     //         video.classList.add('has-media-controls-hidden');
//     //         videoPlayButton = document.getElementsByClassName('video-overlay-play-button')[0];
//     //         videoPlayButton.addEventListener('click', this.hideVideoPlayButton)
//     //     }
//     // },

// //     formatVideoPlayButton: function () {
// //         videoWrapper.insertAdjacentHTML('beforeend', '\
// //     <svg class="video-overlay-play-button" viewBox="0 0 200 200" alt="Play video">\
// //         <circle cx="100" cy="100" r="90" fill="none" stroke-width="15" stroke="#c1c1c1"/>\
// //         <polygon points="70, 55 70, 145 145, 100" fill="#c1c1c1"/>\
// //     </svg>\
// // ')
// //     },
//
//     hideVideoPlayButton: function () {
//         video.play();
//         videoPlayButton.classList.add('is-hidden');
//         video.classList.remove('has-media-controls-hidden');
//         video.setAttribute('controls', 'controls')
//     }
// };
// videoMethods.renderVideoPlayButton();